import ShopaholicOrder from './shopaholic-cart/shopaholic-order';
import JustValidate    from 'just-validate';

export default class CatalogOrder {
	// Default settings for validation
	
	#defaultSettings = {
		errorFieldStyle         :false,
		errorFieldCssClass      :'is-error',
		errorLabelCssClass      :'is-error',
		focusInvalidField       :true,
		lockForm                :true,
		validateBeforeSubmitting:true,
		errorLabelStyle         :{color:''}
	};
	
	constructor({
		form = '_shopaholic-order-form',
		input = '_shopaholic-order-field[required]',
		loader = '.page-order-loader',
		formConfig = {}
	}) {
		this.form       = form;
		this.input      = input;
		this.loader      = loader;
		this.formConfig = formConfig;
		this.init();
	}
	
	addListenerToOrderButton() {
		const obShopaholicCartAdd = new ShopaholicOrder();
		obShopaholicCartAdd.setAjaxRequestCallback((obRequestData, obButton) => {
			obRequestData.error    = (error) => {
				console.error(error);
			};
			obRequestData.loading = this.loader;
			obRequestData.error = (error) => {
				console.error(error);
			};
			return obRequestData;
		}).create();
	}
	
	
	init() {
		const self     = this;
		const form     = document.querySelector(`.${this.form}`);
		if (!form) return;
		
		const validate = new JustValidate(form, {...this.#defaultSettings, ...this.formConfig});
	
		form.querySelectorAll(`.${this.input}`).forEach((el) => {
			const rulesAttribute = el.getAttribute('data-form-validation-rules');
			if (!rulesAttribute) return;
			
			try {
				const rulesObject = JSON.parse(rulesAttribute);
				validate.addField(el, rulesObject);
			} catch (error) {
				// Log error if JSON parsing fails
				// eslint-disable-next-line no-console
				console.info('Invalid JSON string:', error);
			}
		});
		validate.onSuccess(() => {
			self.addListenerToOrderButton();
		});
	}
}
